import React from 'react'
import { SvgIcon } from '@material-ui/core'

function RouteIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-3 -4 20 20">
        <path
          id="Icon_material-directions"
          data-name="Icon material-directions"
          d="M19.046,19.917V16.232H13.151v4.421H10.2V14.759a1.478,1.478,0,0,1,1.474-1.474h7.368V9.6L24.2,14.759Z"
          transform="translate(-10.204 -9.601)"
          fill="#444"
        />
      </svg>
    </SvgIcon>
  )
}

export default RouteIcon
